(function () {
  function applyPatch() {
    var ProductForm = window.customElements.get('product-form');
    if (!ProductForm || !ProductForm.prototype || ProductForm.prototype.__cartBadgeFixApplied) {
      return;
    }

    var originalRenderContents = ProductForm.prototype.renderContents;

    ProductForm.prototype.renderContents = async function (parsedState) {
      try {
        await originalRenderContents.call(this, parsedState);
      } catch (err) {
        console.warn('[cart-badge-fix] theme renderContents failed, falling back to /cart.js sync:', err && err.message);
      }

      try {
        var res = await fetch('/cart.js');
        var cart = await res.json();
        document.querySelectorAll('.thb-item-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      } catch (err) {
        console.warn('[cart-badge-fix] /cart.js sync failed:', err && err.message);
      }
    };

    ProductForm.prototype.__cartBadgeFixApplied = true;
  }

  if (window.customElements && window.customElements.get('product-form')) {
    applyPatch();
  } else if (window.customElements) {
    window.customElements.whenDefined('product-form').then(applyPatch);
  }
})();